import { Link } from 'gatsby'
import { I18nextContext, useTranslation } from 'gatsby-plugin-react-i18next'
import { includes } from 'lodash'
import React from 'react'
import * as rdd from 'react-device-detect'

import { CITIES_WITH_CREDITS_PLANS, CITIES_WITH_FULLL_PLANS } from '../../constants'
import useHomepage from '../../hooks/useHomepage'
import AppleStore from '../../images/apple-store.png'
import FacebookIcon from '../../images/facebook.svg'
import GooglePlay from '../../images/google-play.jpg'
import InstagramIcon from '../../images/instagram.svg'
import Logo from '../../images/logo.svg'
import TikTokIcon from '../../images/tiktok.svg'
import TwitterXIcon from '../../images/twitter-x.svg'
import './footer.less'

const Footer = () => {
  const { t } = useTranslation()
  const { activeCityName, productOffering, onMealPassPage, onMealfixPage, isLunchForLessPage, showModal } =
    useHomepage()
  const context = React.useContext(I18nextContext)
  const pathWithLanguage = (path: string) => {
    return context.language == 'us' ? path : '/' + context.language + path
  }

  const customizeSettings = () => {
    showModal({ name: 'cookies' })
  }

  const isApple = () => {
    return rdd.isSafari || rdd.isIOS
  }

  const priceShownCopy = () => {
    if (typeof window != 'undefined' && window.location.pathname.indexOf('reasons') > -1) {
      return t(
        '$1.99 per meal applied to the first week with the purchase of a 30 day plan. Savings percentages shown on this page are based on typical MealPal savings and vary based on meal selected.',
      )
    } else if (productOffering === 'delivery') {
      return t(
        'Savings percentages shown on this page are based on typical MealPal savings and vary based on meal selected.',
      )
    } else if (includes(CITIES_WITH_CREDITS_PLANS, activeCityName.toLowerCase())) {
      return t('Prices shown in the map reflect the trial credits plan price.')
    } else if (includes(CITIES_WITH_FULLL_PLANS, activeCityName.toLowerCase())) {
      return t('Prices shown in the map reflect the 12 Meal Rollover plan price.')
    }

    return t('Prices shown in the map reflect the trial plan price.')
  }

  return (
    <footer className="footer">
      {isLunchForLessPage && <p className="footer__blue-bar"></p>}
      <div className="footer__wrapper">
        <div className="footer__logo">
          <Link to="/" className="logo__item">
            <img src={Logo} />
          </Link>
          <div className={`footer__${!isLunchForLessPage ? 'links--small' : 'lunch-for-less'}`}>
            <a href={`mailto:${t('hello@mealpal.com')}`} className="footer__link">
              Contact Us
            </a>
            {productOffering === 'lunch' && (
              <Link to={pathWithLanguage('/faq')} className="footer__link">
                FAQs
              </Link>
            )}
            {productOffering === 'dinner' && (
              <Link to={pathWithLanguage('/faq')} className="footer__link">
                FAQs
              </Link>
            )}
            <div onClick={customizeSettings} className="footer__link text">
              <span>Cookies</span>
            </div>
            <a target="_blank" href="https://careers.mealpal.com/" className="footer__link" rel="noreferrer">
              Careers
            </a>
            <a target="_blank" href="https://corporate.mealpal.com/" className="footer__link" rel="noreferrer">
              Corporate Programs
            </a>
            <Link to={pathWithLanguage('/partner')} className="footer__link">
              Restaurant Partnerships
            </Link>
            <a href="mailto:press@mealpal.com" className="footer__link">
              Press
            </a>
            <Link to={pathWithLanguage('/privacy-policy')} className="footer__link">
              Privacy Policy
            </Link>
            <Link to={pathWithLanguage('/terms-and-conditions')} className="footer__link">
              Terms of Use
            </Link>
            {!onMealPassPage && (
              <Link to={pathWithLanguage('/mealpass')} className="footer__link">
                MealPass
              </Link>
            )}
            {!onMealfixPage && (
              <Link to={pathWithLanguage('/mealfix')} className="footer__link">
                MealFix
              </Link>
            )}
          </div>
          <div className={`${!isLunchForLessPage ? 'logo__item' : 'logo__item-textforlunch'}`}>
            &copy; MealPal, Inc.
          </div>
          {!onMealPassPage && !isLunchForLessPage && !onMealfixPage && (
            <p className="logo__item logo__item--lg">
              {t('Price per meal varies based on the plan selected.')} {priceShownCopy()}
            </p>
          )}
        </div>
        <div className={`footer__${!isLunchForLessPage ? 'links' : 'lunch-for-less'}`}>
          <div className="footer__title">SUPPORT</div>
          <div className="footer__links--secondary">
            <a href={`mailto:${t('hello@mealpal.com')}`} className="footer__link">
              Contact Us
            </a>
            {productOffering === 'lunch' && (
              <Link to={pathWithLanguage('/faq')} className="footer__link">
                FAQs
              </Link>
            )}
            {productOffering === 'dinner' && (
              <Link to={pathWithLanguage('/faq')} className="footer__link">
                FAQs
              </Link>
            )}
            <div onClick={customizeSettings} className="footer__link text">
              Cookies
            </div>
          </div>
        </div>
        <div className={`footer__${!isLunchForLessPage ? 'links' : 'lunch-for-less'}`}>
          <div className="footer__title">ABOUT</div>
          <div className="footer__links--secondary">
            <a target="_blank" href="https://careers.mealpal.com/" className="footer__link" rel="noreferrer">
              Careers
            </a>
            <a target="_blank" href="https://corporate.mealpal.com/" className="footer__link" rel="noreferrer">
              Corporate Programs
            </a>
            <Link to={pathWithLanguage('/partner')} className="footer__link">
              Restaurant Partnerships
            </Link>
            <a target="_blank" href="mailto:press@mealpal.com" className="footer__link" rel="noreferrer">
              Press
            </a>
            <Link to={pathWithLanguage('/privacy-policy')} className="footer__link">
              Privacy Policy
            </Link>
            <Link to={pathWithLanguage('/terms-and-conditions')} className="footer__link">
              Terms of Use
            </Link>
            {!onMealPassPage && (
              <Link to={pathWithLanguage('/mealpass')} className="footer__link">
                MealPass
              </Link>
            )}
            {!onMealfixPage && (
              <Link to={pathWithLanguage('/mealfix')} className="footer__link">
                MealFix
              </Link>
            )}
          </div>
        </div>
        <div className={`footer__${!isLunchForLessPage ? 'social-and-apps' : 'lunch-for-less'}`}>
          <div className="footer__title">FOLLOW US!</div>
          <div className="footer__social-icons">
            <a
              className="footer__social-icons--fb"
              target="_blank"
              aria-label="Facebook"
              href="https://www.facebook.com/mealpal"
              rel="noreferrer"
            >
              <img src={FacebookIcon} />
            </a>
            <a
              className="footer__social-icons--ig"
              target="_blank"
              aria-label="Instagram"
              href="https://www.instagram.com/mealpal/"
              rel="noreferrer"
            >
              <img src={InstagramIcon} />
            </a>
            <a
              className="footer__social-icons--tw"
              target="_blank"
              aria-label="Twitter"
              href="https://x.com/mealpal"
              rel="noreferrer"
            >
              <img src={TwitterXIcon} />
            </a>
            <a
              className="footer__social-icons--tk"
              target="_blank"
              aria-label="TikTok"
              href="https://www.tiktok.com/@mealpal"
              rel="noreferrer"
            >
              <img src={TikTokIcon} />
            </a>
          </div>
          <div className="footer__app-links">
            <a href={t('appstore-link')} target="_blank" rel="noreferrer">
              <img src={AppleStore} />
            </a>
            {!isApple() && (
              <a href={t('playstore-link')} target="_blank" rel="noreferrer">
                <img src={GooglePlay} />
              </a>
            )}
          </div>
        </div>
      </div>
      <p className={`logo__item ${!isLunchForLessPage ? 'logo__item--xs' : 'logo__item--textforlunch'}`}>
        {t('Price per meal varies based on the plan selected.')} {priceShownCopy()}
      </p>
    </footer>
  )
}

export default Footer
